import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { AppConfig, APP_CONFIG } from './meta/appconfig';
import { AppRest} from './service/rest';
import { AppDao } from './service/appdao';
import { FGBaseModule } from '@finegold/base';
import { MetadataDao } from './service/metadatadao';
import { CacheService } from './service/cacheservice';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FGBaseModule
  ],
  exports: [
  ],
  declarations: [
  ],
  providers: [
    //AppRest, AppDao,MetadataDao,CacheService
  ]
})
export class FGApiModule {
  static forRoot(config: AppConfig): ModuleWithProviders {
    return {
      ngModule: FGApiModule,
      providers: [
        {
          provide: APP_CONFIG, useValue: config
        },
        AppRest, AppDao,MetadataDao,CacheService
      ]
    };
  }
}
